export const COOKIE_WARN = 'This site uses cookies';

export const OPT_IN_COPY =
  'As part of our mission to bring money to the many, we want to send you updates on the best products, tips to get accepted first time and wise guides to help you take back control of your credit.';

export const NOTIFY_COPY =
  'How would you like us to send you updates about your application? No spam, no marketing, please pick one.';
